var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCyberpayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 60,
    viewBox: "0 0 51 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67969 50.5179C20.265 61.9059 39.0362 61.9059 50.4749 50.5179L29.6506 29.8125L8.67969 50.5179Z",
    fill: "#2F8ED6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68901 9.11133C-2.89634 20.4993 -2.89634 39.1342 8.68901 50.5222L29.66 29.8168L8.68901 9.11133Z",
    fill: "#0F283C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4749 9.1113C39.0362 -2.27668 20.265 -2.27668 8.67969 9.1113L29.6506 29.8167L50.4749 9.1113Z",
    fill: "#DD0A35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyberpayLogo);
export default __webpack_public_path__ + "static/media/cyberpay-logo.28bba4ed32fec0daac73041250fb1202.svg";
export { ForwardRef as ReactComponent };